import { api, handleResponse } from "@/api/config";

const userService = {
  /* =========================================
     GET USERS
  ========================================= */

  getUsers: async (params = {}) => {
    const res = await api.get(
      "/users",
      { params }
    );

    return handleResponse(res);
  },

  /* =========================================
     GET USER BY ID
  ========================================= */

getUserById: async (id) => {
  const res = await api.get(
    `/users/${id}`
  );

  return handleResponse(res);
},

  /* =========================================
     CREATE USER
  ========================================= */
createUser: async (data) => {
  const res = await api.post(
    "/users/create",
    data
  );

  return handleResponse(res);
},

  /* =========================================
     UPDATE USER
  ========================================= */

updateUser: async (
  id,
  data
) => {
  const res = await api.put(
    `/users/${id}`,
    data
  );

  return handleResponse(res);
},

  /* =========================================
     DELETE USER
  ========================================= */

deleteUser: async (id) => {
  const res = await api.delete(
    `/users/${id}`
  );

  return handleResponse(res);
},

  /* =========================================
     USER STATS
  ========================================= */

  getUserStats: async () => {
    const res = await api.get(
      "/users/stats"
    );

    return handleResponse(res);
  },

  /* =========================================
     PASSWORD RESET
  ========================================= */

generateResetLink: async (
  userId
) => {
  const res = await api.post(
    `/users/${userId}/reset-password`
  );

  return handleResponse(res);
},

  /* =========================================
     BACKWARD COMPATIBILITY
     OLD METHODS
  ========================================= */

  getAll(params) {
    return this.getUsers(params);
  },

  getById(id) {
    return this.getUserById(id);
  },

  create(data) {
    return this.createUser(data);
  },

  update(id, data) {
    return this.updateUser(
      id,
      data
    );
  },

  delete(id) {
    return this.deleteUser(id);
  },

  getStats() {
    return this.getUserStats();
  },
};

export default userService;
